import { createContentPropTypes } from '../../../../helpers/content';

const content = {
	header: 'Reason for payment',
	description:
		'Please provide a brief description of this payment. International payments may be rejected if this isn’t completed with all relevant information.',
	reasonCodeHeader: 'View payment purpose codes',
	purposeCodeMsg:
		'You’ll also have to enter a payment purpose code. Please view the list of purpose codes then enter the most suitable code and accompanying description in the field below.',
	emptyReasonWarning:
		'Please provide a brief description for this payment. This should be no more than 140 characters.',
	invalidReasonWarning: 'You can only use the following special characters: / ? : ( ) . , ‘ + -',
};

export const contentPropTypes = createContentPropTypes(content);

export default content;
